'use client'

import { type VariantProps, cva } from 'class-variance-authority'
import { Toggle as TogglePrimitive } from 'radix-ui'
import * as React from 'react'

import { cn } from '@/lib/utils'

const toggleVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-md text-sm disabled:pointer-events-none transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring focus-visible:ring-[3px] outline-none aria-invalid:ring-red-300/20 dark:aria-invalid:ring-red-300/40 aria-invalid:border-red-300 whitespace-nowrap cursor-pointer",
  {
    variants: {
      variant: {
        default: 'bg-white-100 disabled:text-grey-400 disabled:bg-grey-200 data-[state=on]:bg-grey-300',
        secondary:
          'bg-grey-200 border border-grey-500 [&_svg]:text-grey-500 disabled:text-grey-400 disabled:bg-grey-300 data-[state=on]:bg-white-100 data-[state=on]:border-grey-400 data-[state=on]:[&_svg]:text-blue-200',
        outline:
          'border bg-white-100 [&_svg]:text-grey-600 hover:border-black-200 data-[state=on]:[&_svg]:text-black-200 data-[state=on]:border-black-200 hover:[&_svg]:text-black-200 disabled:text-grey-400 disabled:bg-grey-200'
      },
      size: {
        default: 'h-9 p-2.5 min-w-9',
        sm: 'h-7.5 p-2 min-w-8',
        lg: 'h-10 p-3 min-w-10'
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
)

function Toggle({
  className,
  variant,
  size,
  ...props
}: React.ComponentProps<typeof TogglePrimitive.Root> & VariantProps<typeof toggleVariants>) {
  return (
    <TogglePrimitive.Root
      data-slot='toggle'
      className={cn(toggleVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Toggle, toggleVariants }
